import { FaImdb, FcWikipedia, GlobeIconFc, SiLinkedin } from '@icon/react-icons';
import { blue } from '@material-ui/core/colors';
import { FaceTwoTone } from '@material-ui/icons';
import * as userService from 'services/user';
import { SectionTitle, useCompanyFormState, SubSectionTitle } from '../common';
import FacebookIcon from '@material-ui/icons/Facebook';
import { CompanyBasicFormField, CompanyBasicFormFieldProps, createTextAttr } from '../fields';
import { HelperTextTip } from '@components/hepler-text-tip';
import { ColoredChipIconButton } from '@components/colored-elements';
import AddIcon from '@material-ui/icons/Add';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockClosedIcon from '@material-ui/icons/Lock';
import { TrashFill } from '@icon/react-icons';
import { red } from '@material-ui/core/colors';
import Fab from '@material-ui/core/Fab';
import styled from 'styled-components';
// import GroupIcon from '@material-ui/icons/GroupIcon';
import HttpIcon from '@material-ui/icons/Http';
import SocialMediaIcon from '@icon/social-media';
import React, { useEffect, useCallback, useMemo, useRef, useState } from 'react';
import {
  Divider,
  Grid,
  Avatar,
  InputLabel,
  TextField,
  Select,
  FormControl,
  Typography,
  Box,
  Chip,
  Link,
  Tooltip,
} from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { VerifiedDetails } from './section-utils';
import { rbac } from '@lib/common';

export const SectionSocial = ({ social_urls }) => {
  const form = useFormContext();
  const watchOnOtherSocialUrl = form.watch('social_urls');

  const initialNumberofUrls = social_urls.split(',').length;
  const [indexesAttributes, setIndexesAttributes] = useState(
    Array.from(Array(initialNumberofUrls || 1), (_, i) => i)
  );
  const [counterAttributes, setCounterAttributes] = useState(initialNumberofUrls || 1);
  const addAttributes = useCallback(() => {
    setIndexesAttributes(prevIndexes => {
      return [...prevIndexes, counterAttributes];
    });
    setCounterAttributes(prevCounter => prevCounter + 1);
  }, [indexesAttributes, counterAttributes]);

  const removeAttributes = useCallback(index => {
    setIndexesAttributes(prevIndexes => {
      return [...prevIndexes.filter(item => item !== index)];
    });
  }, []);
  const { edit, company } = useCompanyFormState();
  const { user } = userService.useUser();
  const [isLock, setLock] = useState<boolean>(
    (company &&
      company.verified_sections &&
      company.verified_sections.social_section &&
      company.verified_sections.social_section.verified) 
      || edit
  );
  const watchOnVerifiedSections = form.watch('verified_sections');
  const verifiedBy =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.social_section &&
    watchOnVerifiedSections.social_section.verified_by;
  const verifiedAt =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.social_section &&
    watchOnVerifiedSections.social_section.verified_at + ' IST';

  return (
    <>
      <Grid container spacing={2} justify="space-between">
        <Grid item>
          <SectionTitle
            id="social-details"
            icon={<FaceTwoTone style={{ color: blue[500] }} fontSize="large" />}
            title="Online Presence"
            subTitle="Profile details of the Company on the web and social networking services"
          />
        </Grid>
        <Grid item style={{ paddingBottom: '10px' }}>
          <Tooltip
            title={
              isLock ? (
                <>
                  {`Verified by ${verifiedBy}`}
                  <br />
                  {`Verified at ${verifiedAt}`}
                </>
              ) : (
                'Click to Lock the Section'
              )
            }>
            {isLock ? (
              <StyledFab
                color="primary"
                style={{ backgroundColor: 'green' }}
                aria-label="add"
                size="small"
                onClick={() => {
                  setLock(false);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    social_section: { verified: false, verified_by: null, verified_at: null,isLockApplied: false },
                  });
                }}>
                <LockClosedIcon />
              </StyledFab>
            ) : (
              <StyledFab
                color="primary"
                style={{ backgroundColor: 'red' }}
                aria-label="add"
                size="small"
                onClick={() => {
                  setLock(true);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    social_section: {
                      verified: true,
                      verified_by: user.vtr_id,
                      verified_at: new Date().toLocaleString('en-US', { timeZone: 'IST' }),
                      isLockApplied: true,
                    },
                  });
                  // company.verified_sections.social_section.verified_by = user.vtr_id;
                  // company.verified_sections.social_section.verified = true;
                }}>
                <LockOpenIcon />
              </StyledFab>
            )}
          </Tooltip>
          {isLock && <VerifiedDetails verifiedBy={verifiedBy} verifiedAt={verifiedAt} />}
        </Grid>
      </Grid>
      <Divider />
      <br />
      <fieldset disabled={isLock && edit} style={{"border":"none"}}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SubSectionTitle
            icon={<SocialMediaIcon height={'2.1875rem'} width={'2.1875rem'} />}
            title="Social Presence"
            subTitle="URLs of different social media platforms"
          />
          <Divider />
        </Grid>
        <br />
        <br />
        <br />
        {attrs.map((a, i) => (
          <Grid key={i} item xs={4}>
            <CompanyBasicFormField {...a} />
          </Grid>
        ))}
      </Grid>
      </fieldset>
      <br />
      <Grid container justify="space-between" style={{ marginRight: '30px' }}>
        <Grid item>
          <SubSectionTitle
            icon={
              <HttpIcon
                fontSize="large"
                style={{
                  color: '#9be026',
                  background:
                    'radial-gradient(square, rgba(2,0,36,1) 55%, rgba(255,255,255,1) 55%, rgba(255,255,255,1) 100%)',
                }}
              />
              // <ImdbIcon fontSize="large" />
            }
            title="Other Socials"
            subTitle="Additional URLs of social media platforms"
          />
        </Grid>
        <Grid item style={{ paddingBottom: '10px' }}>
          <Tooltip title="Add IMDb details">
            <StyledFab
              disabled={isLock}
              onClick={addAttributes}
              color="primary"
              aria-label="add"
              size="small">
              <AddIcon />
            </StyledFab>
          </Tooltip>
        </Grid>
      </Grid>
      <Divider />
      <br />
      <fieldset disabled={isLock && edit} style={{"border":"none"}}>
      <Grid
        container
        spacing={1}
        justify="space-between"
        // style={{ display: 'flex' }}
        // key={indexOfAttribute}
      >
        {indexesAttributes.map((indexOfAttribute, i) => {
          return socialAttrs.map((attr, i) => {
            return (
              <Grid item container style={{ display: 'flex' }} xs={6} key={indexOfAttribute}>
                <Grid item xs={10}>
                  <CompanyBasicFormField
                    {...attr}
                    fullWidth
                    name={`social_urls[${indexOfAttribute}]`}
                    defaultValue={
                      watchOnOtherSocialUrl ? watchOnOtherSocialUrl[indexOfAttribute] : ''
                    }
                  />
                </Grid>
                {indexesAttributes.length > 1 ? (
                  <Grid item xs={2}>
                    <div
                      style={{
                        marginTop: '10px',
                        justifyContent: 'center',
                        display: 'flex',
                        marginRight: '20px',
                      }}>
                      <Tooltip title="Delete Atrribute">
                        <ColoredChipIconButton
                          onClick={() => removeAttributes(indexOfAttribute)}
                          pointer
                          colored={red[900]}
                          size="small"
                          icon={<TrashFill />}
                        />
                      </Tooltip>
                    </div>
                  </Grid>
                ) : null}
              </Grid>
            );
          });
        })}
      </Grid>
      </fieldset>
    </>
  );
};

const socialAttrs = [createTextAttr('social_urls', 'Social URL', 'Addtional Social URLs')];

const attrs: CompanyBasicFormFieldProps[] = [
  createTextAttr(
    'website',
    'Official Website',
    <HelperTextTip
      text="URL of the official company website"
      tip="[Tip: No third party site links]"
    />,
    <GlobeIconFc />
  ),
  createTextAttr(
    'social_linkedin_url',
    'LinkedIn',
    'URL of the LinkedIn company page',
    <SiLinkedin style={{ color: '#0e76a8' }} />
  ),
  // createTextAttr(
  //   'social_imdb_pro_url',
  //   'IMDb Pro',
  //   'URL of the IMDBPro company page',
  //   <FaImdb
  //     style={{
  //       color: '#f3ce13',
  //       background:
  //         'radial-gradient(circle, rgba(2,0,36,1) 55%, rgba(255,255,255,1) 55%, rgba(255,255,255,1) 100%)',
  //     }}
  //   />
  // ),
  createTextAttr(
    'social_facebook_url',
    'Facebook',
    'URL of the Facebook company page',
    <FacebookIcon style={{ color: '#39569c' }} />
  ),
  createTextAttr('social_wiki_url', 'Wiki', 'URL of the Wiki company page', <FcWikipedia />),
];
const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;
